import * as Services from "../../Service/Service";
import * as Url from "../../Service/Url";

export const GetAllRxBlockPricing = async (payload) => {
  const token = localStorage.getItem("token");
  let {access_Conditions_by_size_or_cost, gpo, pbm, pricing_Structure, rebate_Structure, formulary_Type, specialty_Pharmacy_Network, request_date, all_periods} = payload || {};
  let res = await Services.GET(
    `${Url.GETALLRXBLOCKPRICING}?access_Conditions_by_size_or_cost=${access_Conditions_by_size_or_cost ?? ''}&gpo=${gpo ?? ''}&pbm=${pbm ?? ''}&pricing_Structure=${pricing_Structure ?? ''}&rebate_Structure=${rebate_Structure ?? ''}&formulary_Type=${formulary_Type ?? ''}&specialty_Pharmacy_Network=${specialty_Pharmacy_Network ?? ''}&request_date=${request_date ?? ''}&all_periods=${all_periods ?? false}`,
    token
  );
  return res;
};

export const ImportRxBlockPricing = (
  file,
  UserId,
  GPOName,
  UserRole,
  RequestDate
) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("files", file);
  let res = Services.POSTFORMDATA(
    `${Url.IMPORT_RX_BLOCK_PRICING}?UserId=${UserId}&GPOName=${GPOName}&UserRole=${UserRole}&RequestDate=${RequestDate}`,
      formData,
      token
  );
  return res;
};

export const GetAllGPO = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETALLGPO, token);
  return res;
};

export const GetAllAccessConditionsbysizeorcost = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETAPPACCESSCONDITIONSBYSIZEORCOST, token);
  return res;
};
export const GetAllPlanSponsorType = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETALLPLANSPONSORTYPE, token);
  return res;
};
export const GetAllBenefitBuyingApproach = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETALLBENEFITBUYINGAPPROACH, token);
  return res;
};
export const GetAllRebatesApproachHIV = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETALLREBATESAPPROACHHIV, token);
  return res;
};
export const GetAllRetailNetwork3090 = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETALLRETAILNETWORK3090, token);
  return res;
};

export const GetAllPBM = async (gpoID = '') => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GETALLPBM}?gpoID=${gpoID}`, token);
  return res;
};
export const GetAllContractPeriod = async (gpoID = '') => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GETALLCONTRACTPERIOD}?gpoID=${gpoID}`, token);
  return res;
};
export const GetAllPBMBuyingStructure = async (gpoID = '') => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GETALLPBMBUYINGSTRUCTURE}?gpoID=${gpoID}`, token);
  return res;
};
export const GetRebateStructure = async (gpoID = '') => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GETREBATESTRUCTURE}?gpoID=${gpoID}`, token);
  return res;
};
export const GetAllPresentationAlias = async (gpoID = '') => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GETALLPRESENTATIONONALIAS}?gpoID=${gpoID}`, token);
  return res;
};
export const GetFormularyType = async (extType = '') => {
  const token = localStorage.getItem("token");
  const apiUrl = extType ? `${Url.GETFORMULARYTYPE}?extensionType=${extType}` : Url.GETFORMULARYTYPE;
  let res = await Services.GET(apiUrl, token);
  return res;
};

export const GetAllPricingStructure = async (extType = '') => {
  const token = localStorage.getItem("token");
  const apiUrl = extType ? `${Url.GETALLPRICINGSTRUCTURE}?extensionType=${extType}` : Url.GETALLPRICINGSTRUCTURE;
  let res = await Services.GET(apiUrl, token);
  return res;
};

export const GetSpecialtyPharmacyNetwork = async (extType = '') => {
  const token = localStorage.getItem("token");
  const apiUrl = extType ? `${Url.GETSPECIALTYPHARMACYNETWORK}?extensionType=${extType}` : Url.GETSPECIALTYPHARMACYNETWORK;
  let res = await Services.GET(apiUrl, token);
  return res;
};

export const GetCurrentPeriodData = async (request_date) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GETCURRENTPERIODDATA}?request_date=${request_date}`, token);
  return res;
};

export const CreateOrUpdatePeriodData = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.CREATEUPDATEPERIODDATA, payload, token);
  return res;
};

export const CreateOrUpdateRxBlockPricing = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.CREATEORUPDATERXBLOCKPRICING, payload, token);
  return res;
};

export const CreateOrUpdateGPO = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.CREATEORUPDATEGPO, payload, token);
  return res;
};

export const GetGPOById = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GETGPOBYID}?id=${id}`, token);
  return res;
};

export const GetAllPricingStructureByGPOId = async (gpoId = '') => {
  const token = localStorage.getItem("token");
  const apiUrl =  `${Url.GETALLPRICINGSTRUCTUREBYGPOID}?GPOId=${gpoId}`;
  let res = await Services.GET(apiUrl, token);
  return res;
};

export const GetAllSpecialtyPharmacyNetworkByGPOId = async (gpoId = '') => {
  const token = localStorage.getItem("token");
  const apiUrl = `${Url.GETALLSPECIALTYPHARMACYNETWORKBYGPOID}?GPOId=${gpoId}`;
  let res = await Services.GET(apiUrl, token);
  return res;
};

export const ImportRxBlockPricingForInternalUser = (
  file,
  UserId,
  UserRole
) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("file", file);
  
  let res = Services.POSTFORMDATA(
    `${Url.IMPORTRXBLOCKPRICINGFORINTERNALUSER}?UserId=${UserId}&UserRole=${UserRole}`,
    formData,
    token
  );
  return res;
};

